<div class="passwordless-intermediate__spinner">
  <mm-spinner diameter="50"></mm-spinner>
</div>
